import React from "react";
import "./RefundPolicy.css"; // Custom CSS file for styles

const RefundPolicy = () => {
  return (
    <div className="container refund-policy my-5">
      <h1 className="text-center a mb-4">Refund Policy</h1>
      <p>
        All security deposits placed with AutoMotorAuctions.com are refundable
        only if you do not have any outstanding bids and offers, have not used
        the Buy Now option on a vehicle and have no outstanding balances on your
        account.
      </p>
      <p>
        If a vehicle has already been acquired for you from the Auction Clearing
        House and you (the buyer) do not pay in full the invoice issued in
        connection with this vehicle, you will forfeit your security deposit
        (and it will NOT be refundable) and be liable to pay the service charge
        in full because AutoMotorAuctions.com will need to cover the costs
        related to acquiring the car on your behalf and other related
        operational costs. You will also be responsible for other costs and
        expenses in connection with your purchase.
      </p>
      <p>
        Your refund will be returned to you in the way which it was provided to
        AutoMotorAuctions.com . We process successful refunds within 3 - 7
        business days from the date that you requested a refund.
      </p>
      <p>
        For refunds by credit/debit card, it may take from 5 - 15 working days
        to be reflected back on your credit/debit card (depending on your
        financial institution). This timing is dependent on your bank and/or
        card issuer as we process your refund request within 3 - 7 business days
        from the day you request it (usually on the same business day
        requested).
      </p>
      <p>
        For refunds sent by wire or bank transfers there are/may be additional
        charges as a result of bank fees related to wire transfers. Wire refunds
        will be subject to outgoing wire fees which will be deducted from the
        refund amount.
      </p>
      <p>Wire Refund Fees:</p>
      <ul>
        <li>US Customers - Bank Wire Fee $50.00</li>
        <li>International Customers - Bank Wire Fee $50.00</li>
      </ul>
      <p>
        By checking this box you accept Auto Motor Auctions Refund Policy as set
        out above.
      </p>
      {/* <ul>
        <li>You do not have any outstanding bids and offers.</li>
        <li>
          You have not used the <strong>Buy Now</strong> option on a vehicle.
        </li>
        <li>You have no outstanding balances on your account.</li>
      </ul>
      <p>
        If a vehicle has already been acquired for you from the Auction Clearing
        House and you (the buyer) do not pay in full the invoice issued in
        connection with this vehicle:
      </p>
      <ul>
        <li>
          Your security deposit will be forfeited (and it will{" "}
          <strong>NOT</strong> be refundable).
        </li>
        <li>
          You will be liable to pay the service charge in full to cover costs
          related to acquiring the vehicle and other operational expenses.
        </li>
        <li>
          You will also be responsible for other costs and expenses associated
          with your purchase.
        </li>
      </ul>
      <h2>Refund Process</h2>
      <p>
        Your refund will be returned to you in the same method it was provided
        to AutoMotorAuctions.com. We process successful refunds within{" "}
        <strong>3 - 7 business days</strong> from the date you request the
        refund.
      </p>
      <h3>Refund Timelines:</h3>
      <ul>
        <li>
          <strong>Credit/Debit Card Refunds:</strong> It may take{" "}
          <strong>5 - 15 working days</strong> for the refunded amount to be
          reflected on your card, depending on your financial institution.
          AutoMotorAuctions.com processes refunds within{" "}
          <strong>3 - 7 business days</strong> from the date of your request.
        </li>
        <li>
          <strong>Wire or Bank Transfers:</strong> Refunds by wire transfer may
          incur additional bank fees. Outgoing wire fees will be deducted from
          the refund amount.
        </li>
      </ul>
      <h3>Wire Refund Fees:</h3>
      <ul>
        <li>
          <strong>US Customers:</strong> Bank Wire Fee - $50.00
        </li>
        <li>
          <strong>International Customers:</strong> Bank Wire Fee - $50.00
        </li>
      </ul>
      <p>
        By checking this box, you accept Auto Motor Auctions’ Refund Policy as
        set out above.
      </p> */}
    </div>
  );
};

export default RefundPolicy;
